import { Box, Paper, Stack } from "@mui/material";
import ListLink from "../generic/ListLink";
import { REPORT_VALUES, reportHref } from "../../constants";

const EMPTY_ICON_BG = "#F0F0F0";
const EMPTY_ICON_COLOR = "#6D6D6D";

const REPORT_ITEMS = [
  {
    label: "Top simulations",
    href: reportHref(REPORT_VALUES.countSimsUsed, { days: 90 }),
    iconClass: "fas fa-chart-line",
    iconBg: "#EEEDFE",
    iconColor: "#534AB7",
  },
  {
    label: "Cohort progress",
    href: "/cohorts-insight-dashboard",
    iconClass: "fas fa-chart-bar",
    iconBg: "#FAEEDA",
    iconColor: "#BA7517",
  },
  {
    label: "Standard compliance",
    href: reportHref(REPORT_VALUES.simsFeedback, { days: 90 }),
    iconClass: "fas fa-list",
    iconBg: "#EEEDFE",
    iconColor: "#534AB7",
  },
  {
    label: "User engagement",
    href: reportHref(REPORT_VALUES.rawDataVersionOfSimSummary, { days: 90 }),
    iconClass: "fas fa-user",
    iconBg: "#FAEEDA",
    iconColor: "#BA7517",
  },
];

const ReportsTile = ({ hasSimUsage = true }) => (
  <Paper className="edsimsV2-cohort-dashboard-card" elevation={0}>
    <Box className="edsimsV2-cohort-dashboard-header">
      <Box component="h2" className="edsimsV2-tile-title">
        Reports
      </Box>
      <p className="edsimsV2-tile-body">Frequently used reports</p>
    </Box>
    <Stack
      component="ul"
      aria-label={
        hasSimUsage ? "Frequently used reports" : "Reports with no data yet"
      }
      className={[
        "edsimsV2-reports-list",
        hasSimUsage ? "" : "edsimsV2-reports-empty-list",
      ]
        .filter(Boolean)
        .join(" ")}
      spacing={0}
    >
      {REPORT_ITEMS.map((item, index) => (
        <ListLink
          key={item.label}
          label={item.label}
          href={hasSimUsage ? item.href : undefined}
          iconClass={item.iconClass}
          iconBg={hasSimUsage ? item.iconBg : EMPTY_ICON_BG}
          iconColor={hasSimUsage ? item.iconColor : EMPTY_ICON_COLOR}
          statusLabel={hasSimUsage ? undefined : "No data yet"}
          divider={index < REPORT_ITEMS.length - 1}
        />
      ))}
    </Stack>
  </Paper>
);

export default ReportsTile;
